import * as Yup from "yup";

export const emailValidation = Yup.string()
  .email("Invalid email address")
  .required("Email address is required");

export const passwordValidation = Yup.string().required("Password is required");
